import dayjs, { ConfigType } from 'dayjs';

// Whole calendar months, then the fractional part of the resulting month's days.
export const getProjectEndDate = (startDate: ConfigType, duration: number) => {
    const wholeMonths = Math.floor(duration);
    const anchor = dayjs(startDate).add(wholeMonths, 'month');
    const extraDays = Math.round((duration - wholeMonths) * anchor.daysInMonth());
    return anchor.add(extraDays, 'day').subtract(1, 'day');
};
